/**
 * useOpenFinishedStudentActivity — rouvrir une activité que l'élève a finie, comme aujourd'hui.
 *
 * Le geste de `RealizationsListItem.js:92-108` pour un élève (une ligne faite, sans `onPress`
 * propre) : l'activité est posée comme activité courante, « terminée », puis la route `activity`
 * s'ouvre et la montre dans cet état (`StudentFinishedActivity`, sur le design system). Le même sur l'onglet (bloc « Faites ») et
 * sur les réalisations ; hors live seulement, comme tout l'espace élève (la branche `withGoBack` du
 * legacy n'a lieu qu'en live).
 *
 * L'activité est relue au moment du toucher (`useStore`) : l'écran ne s'abonne pas au compte entier
 * pour un geste.
 */
import { useNavigation } from "@react-navigation/native"
import { useCallback } from "react"
import { useDispatch, useStore } from "react-redux"

import { setCurrentActivity } from "../../../../../../data/redux/actions/activity"
import { findStudentActivity } from "../../../../adapters/student/Activities/studentActivitiesAdapter"
import { selectDisplayedStudent } from "../../../../view-models/shared/displayedStudent"

type PushNavigation = { push: (route: string, params?: object) => void }

export function useOpenFinishedStudentActivity() {
    const navigation = useNavigation() as unknown as PushNavigation
    const dispatch = useDispatch()
    const store = useStore()

    return useCallback(
        (id: string | number) => {
            const account = selectDisplayedStudent(store.getState())
            const activity = findStudentActivity(account, id)
            if (activity == null) return
            dispatch(setCurrentActivity({ activityData: activity, progressStatus: "finished" }) as never)
            navigation.push("activity")
        },
        [dispatch, navigation, store]
    )
}
